/** Brief 12, `Bosh sahifa`. */
export const ruB12Home = {
  "home.greet.morning": "Доброе утро",
  "home.greet.day": "Добрый день",
  "home.greet.evening": "Добрый вечер",
  "home.time.minutes": "{count} мин",
  "home.time.hours": "{count} ч",
  "home.time.days": "{count} дн",
  "home.time.ago": "{duration} назад",
  "home.when.today": "Сегодня",
  "home.when.yesterday": "Вчера",
  "home.when.tomorrow": "Завтра",
  "home.wait.since": "без ответа {duration}",
  "home.summary.operator": "Сегодня осталось {tasks} задач и {waiting} клиентов ждут ответа.",
  "home.summary.operatorCalm": "Всё в порядке. Сегодня {waiting} клиентов ждут ответа.",
  "home.summary.operatorFirst": "Главное: {name} ждёт ответа {duration}.",
  "home.summary.important": "Главное: {count} {text}.",
  "home.summary.decisions": "Вашего решения ждут: {count}.",
  "home.summary.finance": "Сегодня срок: {clients} платежей клиентов и {providers} платежей операторам.",
  "home.empty.title": "Всё в порядке",
  "home.empty.message": "Сегодня нет клиентов в ожидании и задач со сроком. Новые появятся здесь.",
  "home.empty.action": "К перепискам",
  "home.empty.finance": "Сегодня нет ожидаемых платежей и сроков оплаты операторам. Новые появятся здесь.",
  "home.empty.financeAction": "К финансам",
  "home.error.title": "Главная не загрузилась",
  "home.error.message": "Сервер не ответил. Введённые данные сохранены, страницу можно безопасно перезагрузить.",
  "home.error.code": "Ошибка {status} · {time}",
  "home.error.offline": "Ошибка сети · {time}",
  "home.error.status": "Состояние системы",
  "home.denied.message": "Эта роль не видит главную страницу. Если нужно, напишите владельцу агентства.",
  "home.tasks.title": "Задачи на сегодня",
  "home.tasks.count": "{count}",
  "home.tasks.all": "Все",
  "home.tasks.tier.overdue": "Просрочено",
  "home.tasks.tier.today": "Сегодня",
  "home.tasks.tier.next": "Далее",
  "home.tasks.done": "Выполнено",
  "home.tasks.doneToast": "Выполнено: {title}",
  "home.tasks.failed": "Не удалось закрыть задачу: {reason}",
  "home.tasks.allDone": "На сегодня всё выполнено",
  "home.tasks.allDoneHint": "Новая задача появится здесь.",
  "home.task.instalment": "Напомнить об остатке {amount}",
  "home.action.thread": "Открыть переписку",
  "home.kind.call": "Звонок",
  "home.kind.reply": "Сообщение",
  "home.kind.follow_up": "Повторная связь",
  "home.kind.collect_payment": "Оплата",
  "home.kind.request_document": "Документ",
  "home.kind.request_review": "Отзыв",
  "home.kind.other": "Задача",
  "home.waiting.title": "Ждут ответа",
  "home.waiting.link": "К перепискам",
  "home.waiting.aiOff": "ИИ выключен",
  "home.waiting.empty": "Нет клиентов, ожидающих ответа.",
  "home.results.title": "Мои результаты",
  "home.results.period": "эта неделя",
  "home.results.sales": "Продажи",
  "home.results.conversion": "Конверсия",
  "home.results.firstResponse": "Первый ответ",
  "home.results.few": "нужно не менее {minimum} лидов",
  "home.results.report": "Мой отчёт",
  "home.tip.label": "Kapitan AI · совет",
  "home.tip.prepare": "Подготовить предложение",
  "home.tip.laterToast": "Напомним завтра",
  "home.near.deal": "Сделка №{number}",
  "home.problem.tag.noOffer": "Предложение",
  "home.problem.tag.unanswered": "Без ответа",
  "home.problem.tag.idle": "Без движения",
  "home.problem.noOffer": "клиентам не отправлено предложение",
  "home.problem.unanswered": "переписок без ответа более {hours} ч",
  "home.problem.idle": "сделок без движения {days} дн",
  "home.problem.list": "Список",
  "home.problem.see": "Смотреть",
  "home.alert.title": "{branch}: {count} обращений без ответа более {minutes} минут",
  "home.alert.longest": "Самое долгое ожидание: {minutes} минут.",
  "home.alert.names": "Ждут: {names}.",
  "home.alert.away": "В филиале {count} операторов в статусе «Не на работе».",
  "home.alert.distribute": "Распределить очередь",
  "home.alert.done": "Очередь распределена · {names}",
  "home.alert.nothing": "Нечего распределять: все переписки назначены или в филиале нет работающих операторов.",
  "home.alert.failed": "Не удалось распределить очередь: {reason}",
  "home.decisions.title": "Нужно ваше решение",
  "home.decisions.empty": "Все решения приняты.",
  "home.decision.discount": "Скидка",
  "home.decision.reassign": "Назначение",
  "home.decision.leave": "Отпуск",
  "home.decision.reassignTitle": "{name} просит переписку с {client}",
  "home.decision.because": "Причина: {reason}",
  "home.decision.holder": "Сейчас у {name}.",
  "home.decision.margin": "Маржа {margin}% · минимум {min}%",
  "home.decision.approved": "Подтверждено: {title}",
  "home.decision.rejected": "Отклонено: {title}",
  "home.branch.all": "Все",
  "home.kpi.revenue": "Выручка",
  "home.kpi.margin": "Маржа",
  "home.kpi.conversion": "Конверсия",
  "home.kpi.average": "Средний чек",
  "home.kpi.currency": "Валюта",
  "home.kpi.note": "На графике текущие 30 дней, серый пунктир — прошлый период.",
  "home.kpi.report": "Операторы и филиалы · подробный отчёт",
  "home.funnel.title": "Воронка",
  "home.funnel.weakest": "Переход {from} — {to}: {rate}%. Из {base} здесь остановились {lost}.",
  "home.directions.other": "Другое",
  "home.finance.income": "Выручка за сегодня",
  "home.finance.incomeHint": "Платежей: {count}",
  "home.finance.expected": "Ожидается ({days} дн)",
  "home.finance.expectedHint": "Клиентов: {count}",
  "home.finance.provider": "Оплата операторам",
  "home.finance.providerSoon": "{count} в течение {days} дн",
  "home.finance.providerHint": "Броней: {count}",
  "home.finance.refunds": "Возвраты",
  "home.finance.refundsHint": "В этом месяце · сторно: {count}",
  "home.finance.title": "Платежи за сегодня",
  "home.finance.link": "Финансы",
  "home.finance.empty": "Сегодня платежей нет",
  "home.finance.col.client": "Клиент",
  "home.finance.col.deal": "Сделка",
  "home.finance.col.amount": "Сумма",
  "home.finance.col.due": "Срок",
  "home.finance.col.state": "Статус",
  "home.finance.state.expected": "Ожидается",
  "home.finance.state.paid": "Оплачено · {via}",
  "home.finance.state.overdue": "Просрочено",
  "home.finance.state.planned": "В плане",
} as const;
